import React from "react";
import Select, { components } from "react-select";
import { GoTriangleDown } from "react-icons/go";
import { useBookingEditText } from "../text";
import { createTypographyHelper } from "../../../../utils/typography";

const ClockIcon = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/icons/form-icons/clock.svg";

const UsageDurationDropdown = ({ value, onChange, options }) => {
  const { t, language } = useBookingEditText();
  const getTypographyClass = createTypographyHelper(language);

  return (
    <div className="tw:flex tw:flex-col">
      <div className={`tw:mb-2 tw:text-[#8d8d8d] ${getTypographyClass(13)}`}>
        {t("editBooking.BookingEditPage.basicInformation.usageDuration")}
      </div>
      <div className="tw:relative">
        <Select
          value={value}
          onChange={onChange}
          options={options}
          className="tw:font-hanken-grotesk"
          classNamePrefix="react-select-duration"
          styles={{
            control: (baseStyles) => ({
              ...baseStyles,
              height: '50px',
              borderRadius: '5px',
              border: '1px solid #e8e8e8',
              backgroundColor: '#ffffff',
              fontSize: '14px',
              paddingLeft: '36px',
              boxShadow: 'none',
              '&:hover': {
                border: '1px solid #e8e8e8',
              },
            }),
            valueContainer: (baseStyles) => ({
              ...baseStyles,
              paddingLeft: '14px',
            }),
            menu: (baseStyles) => ({
              ...baseStyles,
              borderRadius: '5px',
              marginTop: '4px',
            }),
            option: (baseStyles, state) => ({
              ...baseStyles,
              fontSize: '14px',
              backgroundColor: state.isSelected ? '#dbbe78' : state.isFocused ? '#eddfbb' : '#ffffff',
              color: state.isSelected ? '#ffffff' : '#282828',
              cursor: 'pointer',
            }),
          }}
          components={{
            DropdownIndicator: (props) => (
              <components.DropdownIndicator {...props}>
                <div className="tw:pr-2">
                  <GoTriangleDown color="#8d8d8d" size={16} />
                </div>
              </components.DropdownIndicator>
            ),
            IndicatorSeparator: () => null,
          }}
        />
        <span className="tw:absolute tw:left-[14px] tw:top-1/2 tw:-translate-y-1/2">
          <img alt="clock" src={ClockIcon} className="tw:w-[18px] tw:h-[18px]" />
        </span>
      </div>
    </div>
  );
};

export default UsageDurationDropdown;
